import { useDispatch, useSelector } from "react-redux";
import { logout } from "../features/auth/authSlice";
import { resetVesselState } from "../store/vesselOverviewSlice";
import { Link, useNavigate } from "react-router-dom";
import headerLogo from "../assets/images/logo.png";

const Header = () => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const firstName = userData.firstName || "User";
  const company = userData.company || {};
  const companyLogo = company.logo || "";

  const handleLogout = () => {
    dispatch(logout());
    dispatch(resetVesselState());
    localStorage.removeItem("token");
    navigate("/login");
  };

  const openLogoutConfirm = () => {
    // Pass the actual logout function to the global handler
    if (window.showLogoutConfirm) {
      window.showLogoutConfirm(handleLogout);
    }
  };

  return (
    <>
      <div className="flex items-center justify-between h-full w-full px-6 py-6 pt-8">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <a
            href={process.env.REACT_APP_DASHBOARD_URL}
            rel="noopener noreferrer"
          >
            <img src={headerLogo} alt="Company Logo" className="w-auto" />
          </a>
        </div>

        {/* User section */}
        <div className="flex items-center gap-4">
          <span className="text-gray-700 font-normal">
            Welcome <span className="text-gray-700 font-bold">{firstName}</span>
          </span>

          {companyLogo && (
            <div className="w-10 px-2 py-2 bg-white rounded-full">
              <img
                src={companyLogo}
                alt="Company Logo"
                className="h-full w-full object-contain"
              />
            </div>
          )}

          {/* Logout */}
          <button
            onClick={openLogoutConfirm}
            title="Logout"
            className="text-[#27ade3] hover:text-gray-600 text-[22px]"
          >
            <i className="fa fa-sign-out" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Header;